export class CheckBoxOptionsBeanModel {
    public option1: boolean;
    public option2: boolean;
    public option3: boolean;
    public option4: boolean;
    public option5: boolean;
    public option6: boolean;
    public option7: boolean;
    public option8: boolean;
    public option9: boolean;
    public option10: boolean;
    public option11: boolean;
    public option12: boolean;
    public option13: boolean;
    public option14: boolean;
    public option15: boolean;
    public option16: boolean;
    public option17: boolean;
    public option18: boolean;
    public option19: boolean;
    public option20: boolean;
}
